export default __webpack_public_path__ + "static/media/mouth.7cb74b32.ogg";